<div mat-dialog-title class="ds">
  <span>{{appStrings.accounts_search}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
@if (loading) {
  <div class="loading" [ngClass]="{'mobile': isMobile}">
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
@if (!loading) {
  <div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
    <div class="leads-search-container">
      <form [formGroup]="leadsSearchForm" (keyup.enter)="btnCallback(1)">
        <ds-autocomplete id="leadOwner" [isDisabled]="isAccountManager" class="fill-width" [options]="accountManagers"
          [label]="appStrings.followUp_leads_leadOwner" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="leadsSearchForm.controls.leadOwnerId">
        </ds-autocomplete>
        <ds-textfield id="companyName" class="fill-width" [label]="appStrings.accounts_company" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="leadsSearchForm.controls.companyName">
        </ds-textfield>
        <ds-select id="status" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_leads_status" [dropOptions]="statuses"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="leadsSearchForm.controls.statusId">
        </ds-select>
        <ds-select id="country" class="fill-width" (selectionChange)="handleCountryChange()" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_country"
          [dropOptions]="countries" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="leadsSearchForm.controls.countryId">
        </ds-select>
        <ds-textfield id="city" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_editLead_city"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="leadsSearchForm.controls.city">
        </ds-textfield>
        @if (isSelectState) {
          <ds-select id="state" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_state_province"
            [dropOptions]="states" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="leadsSearchForm.controls.stateId">
          </ds-select>
        }
        @if (!isSelectState) {
          <ds-textfield id="province" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_state_province"
            [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="leadsSearchForm.controls.stateName">
          </ds-textfield>
        }
      </form>
    </div>
  </div>
}
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
        [type]="button.type" (onClick)="btnCallback(i)" [label]="button.label" [isDisabled]="button.disableEmpty && disableButtons">
      </ds-button>
    }
  </div>
</div>
